"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/*
 * Defines the style of the toast
 */
var AddinToastStyle;
(function (AddinToastStyle) {
    // The toast style for a critical error
    AddinToastStyle[AddinToastStyle["Danger"] = 0] = "Danger";
    // The toast style for informational purposes (default)
    AddinToastStyle[AddinToastStyle["Info"] = 1] = "Info";
    // The toast style for a successful operation
    AddinToastStyle[AddinToastStyle["Success"] = 2] = "Success";
    // The toast style for a non-critical error
    AddinToastStyle[AddinToastStyle["Warning"] = 3] = "Warning";
})(AddinToastStyle = exports.AddinToastStyle || (exports.AddinToastStyle = {}));
//# sourceMappingURL=addin-toast-style.js.map